//A reducer is a function that determines changes to an application's state.
//It uses the action it receives to determine this change.  Redux is used
//to help manage the applications state changes in a single store so that
//they behave consistently.

import { combineReducers } from 'redux'; //Imports the combine Reducer action which combines multiple reducers together.
import staticReducers from "./staticReducers";

//The rootReducer should be the combination of all the reducers.
const rootReducer = combineReducers(staticReducers);

export default rootReducer







// import authReducer from './authReducer';
// import { firestoreReducer } from 'redux-firestore'; //A premade reducer which is used to sync the redux with firestore database in the background.
// import { firebaseReducer } from 'react-redux-firebase'; //Used for Firebase Authentication.
// import CreateContentReducer from './CreateContentReducer'
// import toggleBooleanFormsReducer from './toggleBooleanFormsReducer';
// import toggleEditContentReducer from './toggleEditContentReducer';
// import QuestionReducer from './questionReducer';
// import PublishCoursesReducer from './publishCoursesReducer';
// import marketplaceSelectedCourseReducer from './marketplaceReducer'
// import algorithmReducer from './algorithmReducer';
// import createCourseReducer from './createCourseReducer';
// import highlightContentReducer from './highlightContentReducer';
// import createLectureReducer from './createLectureReducer';
// import createQuestionReducer from './createQuestionReducer';
// import publishCourseReducer from './publishCourseReducer';
// import videoReducer from './videoReducer';
// import footerReducer from './footerReducer';
// import dashboardReducer from './dashboardReducer';
// import publishReducer from './publishReducer';
// import homepageReducer from './homepageReducer';
// import feedbackReducer from './feedbackReducer';
// import settingsReducer from './settingsReducer';


//import selectedCourseReducer from './selectedCourseReducer' //used to track which course has been selected by the user (for making lectures)
//import selectedLectureReducer from './selectedLectureReducer' //used to track which lecture has been selected by the user (for making questions/answers)

// "firestoreReducer" is used to sync up firestore database for course collections to the "state"
// "firebaseReducer" is used to sync up the firebase User Authentication functionality to the "state".
// const rootReducer = combineReducers({ 
//     FeedbackReducer: feedbackReducer,
//     PublishReducer: publishReducer,
//     DashboardReducer: dashboardReducer,
//     VideoModal: videoReducer,
//     FooterReducer: footerReducer,
//     CourseDisplayModals: createCourseReducer,
//     LectureDisplayModals: createLectureReducer,
//     QuestionDisplayModals: createQuestionReducer,
//     publishCourseReducer: publishCourseReducer,
//     auth: authReducer,
//     homepageReducer: homepageReducer,
//     Marketplace: marketplaceSelectedCourseReducer,
//     algorithm: algorithmReducer,
//     highlightContent: highlightContentReducer,
//     CreateContent: CreateContentReducer,
//     ToggleBooleanForms: toggleBooleanFormsReducer,
//     ToggleEditContent: toggleEditContentReducer,
//     CreateQuestion: QuestionReducer,
//     PublishCoursesContent: PublishCoursesReducer,
//     firestore: firestoreReducer, 
//     firebase: firebaseReducer,
//     settingsReducer: settingsReducer,
// });

// export default rootReducer

